import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-manage" }
const _hoisted_2 = { class: "download-excel-btn" }
const _hoisted_3 = { class: "search-area" }
const _hoisted_4 = {
  key: 0,
  class: "center"
}
const _hoisted_5 = {
  key: 1,
  class: "plan"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "plan"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "pagination-area" }
const _hoisted_10 = { class: "count" }

import {ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getRequestList } from "@/api";
import { getRequestTypeValue, getRequestStatusTypeValue, getPaymentTypeValue, getPaymentCycleTypeValue, getDocumentTypeValue } from "@/utils/getValueForKey";
import { getBeusPlanLName, getBaPlanLName, getTagColor } from "@/utils";
import { createExcel } from "@/utils/createExcel"
import  { DocumentTypeKeys }  from "@/types/constants";
import { Request } from '@/types/Request';
import StatusTag from '@/components/StatusTag.vue';
import type { TableInstance } from 'element-plus';
import IconBeusGray from '@/assets/images/ico-beus-g.svg';
import IconBiGray from '@/assets/images/ico-bi-g.svg';
import { ElMessageBox } from 'element-plus';
import CommonError from '@/components/CommonError.vue';
import CommonLoader from '@/components/CommonLoader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagePage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const data = ref<Request[]>([]);
const totalCount = ref<number>(0);
const currentPage = ref<number>(1);
const pageSize = ref<number>(100);
const loading = ref<boolean>(false);
const isError = ref<boolean>(false);
const searchKeyword = ref('');
const clearSearch = () => {
  searchKeyword.value = '';
};
const sortValue = ref<string | undefined>(undefined);
const selectedFilters = ref<{ [key: string]: string[] } | undefined>({});

const fetchData = async () => {
  loading.value = true;
  const params: Record<string, any> = {
    pageNum: currentPage.value,
    pageSize: pageSize.value,
  }

  if (searchKeyword.value.length >= 2) {
    params.userId = searchKeyword.value;
  }

  if (sortValue.value) {
    params.sort = sortValue.value;
  }

  if (selectedFilters.value) {
    const searchFilters: Record<string, any> = {};
    Object.entries(selectedFilters.value).forEach(([key, value]) => {
      if (value.length > 0) {
        searchFilters[key] = value;
      }
    });

    if (Object.keys(searchFilters).length > 0) {
      params.search = searchFilters;
    }
  }


  try {
    const response = await getRequestList(params);
    if(response.success) {
      // console.log(response.result);
      totalCount.value = response.result.count;
      data.value = response.result.list;
    }
  } catch (error) {
    loading.value = false;
    isError.value = true;
    console.error('Error Message:', error);
  } finally {
    loading.value = false;
  }
}

watch(
  () => route.query.param,
  (newParam) => {
    if (newParam) {
      searchKeyword.value = newParam as string;
      fetchData();
    } else {
      searchKeyword.value = '';
      fetchData();
    }
  },
  { immediate: true }
);

const handleSearch = async () =>  {
  if(searchKeyword.value.length < 2) {
    ElMessageBox.alert('검색어는 2자 이상 입력해주세요.', {
      confirmButtonText: '확인',
    });
    return;
  }
  router.replace({ path: '/request/manage', query: { param: searchKeyword.value } });
}

const toRequestView = (id: string) => router.push(`/request/view/${id}`)

const handleSizeChange = (size: number) => {
  pageSize.value = size;
  fetchData();
}
const handlePageChange = (page: number) => {
  currentPage.value = page;
  fetchData();
};

const handleSortChange = ({ prop, order }: { prop: string; order: string }) => {
  if (order === "ascending") {
    sortValue.value = prop;
  } else if (order === "descending") {
    sortValue.value = `-${prop}`
  } else {
    sortValue.value = undefined;
  }
  fetchData();
};

const handleFilterChange = (filters: Record<string, string[]>) => {
  selectedFilters.value = filters || [];
  fetchData();
};

const tableRef = ref<TableInstance>()

const handleReset = () => {
  searchKeyword.value = '';
  currentPage.value = 1;
  pageSize.value = 30;
  tableRef.value?.clearFilter();
  tableRef.value?.clearSort();
  sortValue.value = undefined;
  selectedFilters.value = undefined;
  router.replace({ path: '/request/manage' });
  fetchData(); 
}

const uniqueDocTypes = (docList: DocumentTypeKeys[]) => Array.from(new Set(docList))

const downloadExcel = async () => {
  const params: Record<string, any> = {
    pageNum: currentPage.value,
    pageSize: totalCount.value,
  }

  try {
    const response = await getRequestList(params);
    if(response.success) {
      // console.log(response.result);
      createExcel(response.result.list);
    }
  } catch (error) {
    loading.value = false;
    isError.value = true;
    console.error('Error Message:', error);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tooltip, {
        content: "엑셀 다운로드",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            "aria-label": "엑셀 다운로드",
            onClick: downloadExcel,
            class: "btn-icon"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "file-excel" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
        placeholder: "뷰저블 계정을 입력하세요.",
        clearable: "",
        onClear: clearSearch,
        size: "large",
        style: {"width":"300px"},
        class: "input-search",
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchKeyword.value.length >= 2 ? handleSearch() : null), ["enter"]))
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            "aria-label": "검색",
            onClick: handleSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-magnifying-glass" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "info",
        size: "large",
        class: "btn-reset",
        onClick: handleReset
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rotate-left" })
        ]),
        _: 1
      })
    ]),
    (!loading.value && !isError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_table, {
            data: data.value,
            "default-sort": { prop: 'id', order: 'descending' },
            style: {"width":"100%"},
            ref_key: "tableRef",
            ref: tableRef,
            onSortChange: handleSortChange,
            onFilterChange: handleFilterChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "자세히",
                width: "60",
                align: "center",
                fixed: ""
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    "aria-label": "자세히",
                    onClick: ($event: any) => (toRequestView(scope.row.requestId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-file-lines" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "state",
                label: "상태",
                width: "120",
                align: "center",
                fixed: "",
                "column-key": "state",
                filters: [
            { text: '플랜 생성 대기', value: 'CREATED_REQUEST_PLAN' },
            { text: 'PV 충전 대기', value: 'CREATED_REQUEST_PV' },
            { text: 'Jam 충전 대기', value: 'CREATED_REQUEST_JAM' },
            { text: '부가 서비스 처리 대기', value: 'CREATED_REQUEST_ADDITIONAL' },
            { text: '무통장 입금 대기', value: 'DAY_PAYMENT_WIRE' },
            { text: '무통장 입금 지연', value: 'DAY_PAYMENT_WIRE_DELAY' },
            { text: '카드 결제 대기', value: 'DAY_PAYMENT_CARD' },
            { text: '세금 계산서 발행', value: 'DAY_INVOICE_TAX' },
            { text: '서류 발행', value: 'DAY_INVOICE' },
            { text: '플랜 연장 필요', value: 'NEED_TO_EXTEND' },
            { text: '이슈 없음', value: 'NON_ISSUE' },
            { text: '리퀘스트 종료', value: 'COMPLETED_REQUEST' },
          ]
              }, {
                default: _withCtx((scope) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.state, (stat, index) => {
                    return (_openBlock(), _createBlock(StatusTag, {
                      key: index,
                      color: _unref(getTagColor)(stat),
                      size: "small",
                      text: _unref(getRequestStatusTypeValue)(stat)
                    }, null, 8, ["color", "text"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "companyName",
                label: "회사명 / 계정",
                fixed: "",
                width: "220",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.companyName), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(scope.row.userId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "requestType",
                label: "요청 유형",
                width: "100",
                align: "center",
                "column-key": "requestType",
                filters: [
            { text: '플랜', value: 'PLAN' },
            { text: 'PV 충전', value: 'PV_CHARGE' },
            { text: 'Jam 충전', value: 'JAM_CHARGE' },
            { text: '부가 서비스', value: 'ADDITIONAL' }
          ]
              }, {
                default: _withCtx((scope) => [
                  _createVNode(StatusTag, {
                    color: _unref(getTagColor)(scope.row.requestType),
                    size: "small",
                    text: _unref(getRequestTypeValue)(scope.row.requestType)
                  }, null, 8, ["color", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "플랜명",
                width: "140"
              }, {
                default: _withCtx((scope) => [
                  (!scope.row.beusPlanNumber && !scope.row.baPlanNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " - "))
                    : _createCommentVNode("", true),
                  (scope.row.beusPlanNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createElementVNode("img", {
                          src: _unref(IconBeusGray),
                          alt: "히트맵 플랜"
                        }, null, 8, _hoisted_6),
                        _createTextVNode(" " + _toDisplayString(_unref(getBeusPlanLName)(Number(scope.row.beusPlanNumber))), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (scope.row.baPlanNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createElementVNode("img", {
                          src: _unref(IconBiGray),
                          alt: "저니맵 플랜"
                        }, null, 8, _hoisted_8),
                        _createTextVNode(" " + _toDisplayString(_unref(getBaPlanLName)(Number(scope.row.baPlanNumber))), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "useStartDate",
                label: "사용 시작일",
                width: "110",
                align: "center",
                sortable: "custom"
              }),
              _createVNode(_component_el_table_column, {
                prop: "useEndDate",
                label: "사용 종료일",
                width: "110",
                align: "center",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.useEndDate ? scope.row.useEndDate : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "period",
                label: "사용 기간",
                width: "100",
                align: "center",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.period)
                    ? (_openBlock(), _createBlock(StatusTag, {
                        key: 0,
                        color: "gray",
                        size: "small",
                        text: `${scope.row.period}개월`
                      }, null, 8, ["text"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "recurring",
                label: "자동 갱신",
                width: "100",
                align: "center",
                "column-key": "recurring",
                filters: [
              { text: 'Yes', value: true },
              { text: 'No', value: false }
            ]
              }, {
                default: _withCtx((scope) => [
                  _createVNode(StatusTag, {
                    color: scope.row.recurring ? 'blue': 'gray',
                    size: "small",
                    text: scope.row.recurring ? 'Yes' : 'No'
                  }, null, 8, ["color", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "paymentType",
                label: "결제 방식",
                width: "100",
                align: "center",
                "column-key": "paymentType",
                filters: [
              { text: '무통장', value: 'wire' },
              { text: '카드', value: 'card' },
              { text: '무상', value: 'free' }
            ]
              }, {
                default: _withCtx((scope) => [
                  _createVNode(StatusTag, {
                    color: _unref(getTagColor)(scope.row.paymentType),
                    size: "small",
                    text: _unref(getPaymentTypeValue)(scope.row.paymentType)
                  }, null, 8, ["color", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "amount",
                label: "총 결제 금액",
                width: "110",
                align: "right",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(new Intl.NumberFormat().format(scope.row.amount || 0)) + " 원 ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "paymentDate",
                label: "최초 결제일",
                width: "110",
                align: "center",
                sortable: "custom"
              }),
              _createVNode(_component_el_table_column, {
                prop: "paymentCycle",
                label: "결제 주기",
                width: "110",
                align: "center",
                "column-key": "paymentCycle",
                filters: [
              { text: '일시납', value: 0 },
              { text: '월납', value: 1 },
              { text: '격월납', value: 2 },
              { text: '분기납', value: 3 },
              { text: '4개월납', value: 4 },
              { text: '반기납', value: 6 },
              { text: '연납', value: 12 }
            ]
              }, {
                default: _withCtx((scope) => [
                  _createVNode(StatusTag, {
                    color: _unref(getTagColor)(String(scope.row.paymentCycle)),
                    size: "small",
                    text: scope.row.paymentCycle ? _unref(getPaymentCycleTypeValue)(scope.row.paymentCycle) : _unref(getPaymentCycleTypeValue)(0)
                  }, null, 8, ["color", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "docList",
                label: "발행 서류",
                width: "140",
                align: "center",
                "column-key": "docList",
                filters: [
              { text: '세금계산서', value: 'TAX_INVOICE' },
              { text: '견적서', value: 'QUOTATION' },
              { text: '계약서', value: 'CONTRACT' },
              { text: '청구서', value: 'INVOICE' },
              { text: '거래명세서', value: 'TRANSACTION' },
              { text: '정산요청서', value: 'SETTLEMENT' }
            ]
              }, {
                default: _withCtx((scope) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueDocTypes(scope.row.docList), (doc, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "center"
                    }, _toDisplayString(_unref(getDocumentTypeValue)(doc)), 1))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "memo",
                label: "메모",
                width: "300"
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createTextVNode(" 총 ")),
              _createElementVNode("strong", null, _toDisplayString(totalCount.value), 1),
              _cache[4] || (_cache[4] = _createTextVNode("개의 리퀘스트 "))
            ]),
            _createVNode(_component_el_pagination, {
              "current-page": currentPage.value,
              "page-size": pageSize.value,
              "page-sizes": [30, 50, 100],
              total: totalCount.value,
              layout: "sizes, prev, pager, next",
              onSizeChange: handleSizeChange,
              onCurrentChange: handlePageChange
            }, null, 8, ["current-page", "page-size", "total"])
          ])
        ], 64))
      : (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, { key: 1 }))
        : (isError.value && !loading.value)
          ? (_openBlock(), _createBlock(CommonError, {
              key: 2,
              message: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요."
            }))
          : _createCommentVNode("", true)
  ]))
}
}

})